<template>
<!-- TODO:有点击bug -->
    <div class="header-top">
       <div class="top-main flex-align-between">
           <ul class="main-nav-left flex-align">
                <li><a href="/" rel="noopener noreferrer"><img src="../../../assets/header/logo2.png" alt=""></a></li>
            </ul>
            <ul class="main-nav-right flex-align">
                <!-- <li class="flex-align">联系方式<span></span>010-88512948</li> -->
                <li class="flex-align"><img src="../../../assets/header/logo3.png" alt=""></li>
                <!-- <li v-for="(nav, index) in navs" 
                    :key="index" 
                    :class="{active: ( isActive === index && isActive !== null  )}"
                    @mouseleave="mouseLeave(index)"
                    @mouseenter="mouseEnter(index)"
                    @click="gotoPage(index,nav)">
                   {{nav.name}}
                </li> -->
               
            </ul>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type:Number,
            default:null,
        }
    },
    data() {
        return {
            isActive:0,
            currentPage:0,
            timer:null,
            navs:[{
                name:'首页',
                href:'/home'
            },{
                name:'通知公告',
                href:'/list/course'
            },{
                name:'组考单位',
                href:'/list/information'
            },{
                name:'特色服务',
                href:'/list/learning'
            },{
                name:'巡展活动',
                href:'/list/elegant'
            },{
                name:'关于我们',
                href:'/project'
            },
            // {
            //     name:'实验区名录',
            //     href:'/experiment_list'
            // }
            
            ]
        }
    },

    methods: {
        gotoPage(index,nav){
            this.$nextTick(function(){
                this.$router.push(nav.href)
            })
            
        },
         //   鼠标移入
         mouseEnter(index) {
             this.isActive = index;
         },
        //   鼠标移除
         mouseLeave(index) {
            this.isActive = this.page;
         },
    },
     mounted: function() {
            this.isActive = this.page;
     },
    //  updated: function() {
    //     this.currentPage = this.page;
    //  }
    
}
</script>

<style lang="less" scoped>
    .header-top {
        height: 80px;
        font-size: 16px;
        background-color: #fff;
        // background-image: linear-gradient(to bottom,#1c4b90,#1352b0);
    }

    .top-main {
        box-sizing: border-box;
        margin: 0 auto;
        padding-top:10px;
        width: 1200px;
    }
    .main-nav-left {
        li {
            // margin-right: 19px;
            cursor: auto;
            color: #fff;
            // &:first-child {
            //     margin-right: 29px;
            // }

            // &:last-child a{
            //     border-left: 1px solid #fff;
            //     padding-left:18px;
            // }

            a img{
                    width: 300px;
                    vertical-align: middle;
                }
            

        }
        
    }

    .main-nav-right {
        li {
            padding: 0 65px;
            line-height: 60px;
            color: #999999;
            // background-color: #1c4b90;
            cursor: pointer;
            span {
              display: inline-block;
              width: 1px;
              height: 15px;
              background-color: #999999;
              margin:0 18px;
            }
        }

       
    }

    a {
        display: block;
        line-height: 64px;
        color: #fff;
    }
</style>